/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CounterIcon16Light } from './CounterIcon16Light';
import { CounterIcon16Regular } from './CounterIcon16Regular';
import { CounterIcon16Solid } from './CounterIcon16Solid';
import { CounterIcon20Light } from './CounterIcon20Light';
import { CounterIcon20Regular } from './CounterIcon20Regular';
import { CounterIcon20Solid } from './CounterIcon20Solid';
import { CounterIcon24Regular } from './CounterIcon24Regular';
import { CounterIcon24Solid } from './CounterIcon24Solid';
import { CounterIcon32Regular } from './CounterIcon32Regular';
import { CounterIcon64Regular } from './CounterIcon64Regular';
var sizes = {
    16: {
        light: CounterIcon16Light,
        regular: CounterIcon16Regular,
        solid: CounterIcon16Solid,
    },
    20: {
        light: CounterIcon20Light,
        regular: CounterIcon20Regular,
        solid: CounterIcon20Solid,
    },
    24: {
        regular: CounterIcon24Regular,
        solid: CounterIcon24Solid,
    },
    32: {
        regular: CounterIcon32Regular,
    },
    64: {
        regular: CounterIcon64Regular,
    },
};
export var CounterIcon = forwardRef('CounterIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
